module.exports = __webpack_public_path__ + "img/bolt-icon.2e449c60.svg";